import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull/components/Typography';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import { useStore } from '~/store/store-context';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
import { renderExpirationDateModal } from './ExpirationDateCell.utils';
export function ExpirationDateCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t: draftCellsTexts } = useLocaleKeys('proposal.draftsDashboard.cells');
    const worksAt = useStore(selectors.user.business);
    const expirationDaysAfterSending = draft.expirationDaysAfterSending();
    const defaultExpirationDays = draft.defaultExpirationDays(worksAt);
    const onClick = ()=>onOpenModal({
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return renderExpirationDateModal({
                    draft,
                    setDraft,
                    title: draftCellsTexts.draft.expirationDate(),
                    defaultExpirationDays
                });
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-expiration-date-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "expiration-date-".concat(index),
            children: expirationDaysAfterSending != null ? draftCellsTexts.shared.daysAfterSending({
                count: expirationDaysAfterSending
            }) : draftCellsTexts.shared.notSet()
        })
    });
}
